import { useDelete } from "../../api";

export type CancelMembershipReasonCode =
  | "not_saving_enough"
  | "want_to_take_a_break"
  | "issue_with_membership"
  | "something_else";

interface CancelReason {
  code: CancelMembershipReasonCode;
  addition?: string;
}

export function useCancelSubscription() {
  const deleteRequest = useDelete();

  return async (
    partnerId: string,
    subscriptionId: string,
    reason: CancelReason
  ) => {
    await deleteRequest(
      `/api/v3/portal/partners/${partnerId}/subscriptions/${subscriptionId}`,
      {
        cancel_exit_feedback: reason.addition,
        cancel_exit_reason_code: reason.code,
      }
    );
  };
}
